export default "__VITE_ASSET__4UMc2BT2__"